import { api } from '@shared/api/api';

type Wristband = App.Domain.Wristband.Data.WristbandData;

export function reredeemAccessVoucher(registrationId: number, accessVoucherId: number) {
  return api.post<Wristband & { zpl: string }>(
    `/registrations/${registrationId}/access-vouchers/${accessVoucherId}/recreate-wristband`
  );
}
